package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.model.Query
import ai.flowstorm.common.ui.FilterForm
import ai.flowstorm.common.ui.Form
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.studio.model.ProfileRecord
import io.kvision.form.text.Text
import io.kvision.i18n.tr
import kotlinx.serialization.Serializable

class ProfileRecordUserFilterForm : Form<ProfileRecordUserFilterForm.FormData>(FormData.serializer()), FilterForm {

    @Serializable
    data class FormData (
        val userId: String? = null,
        val turnId: String? = null,
        val sessionId: String? = null
    )

    init {
        marginTop = UiHelpers.spacing
        marginRight = UiHelpers.spacing
        add(
            FormData::userId,
            Text(label = tr("User ID"))
        )
    }

    override fun load(query: Query) {
        val userId =
            query.filters.firstOrNull { it.field == ProfileRecord::user_id.name }?.value as String?
        form.setData(FormData(userId = userId))
    }

    override fun save(query: Query) {
        val filter = form.getData()
        query.filters.clear()
        if (!filter.userId.isNullOrEmpty()) {
            query.filters.add(Query.Filter(ProfileRecord::user_id.name, Query.Operator.eq, filter.userId))
        }
    }
}

